module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "custom-class": "w-400 h-300",
      "title": "修改密码"
    }
  }, [_c('div', {
    staticClass: "ovf-auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "old_pwd"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.old_pwd),
      expression: "form.old_pwd",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.form.old_pwd)
    },
    on: {
      "input": function($event) {
        _vm.form.old_pwd = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "new_pwd"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.new_pwd),
      expression: "form.new_pwd",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.form.new_pwd)
    },
    on: {
      "input": function($event) {
        _vm.form.new_pwd = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-20"
  }, [_c('el-button', {
    staticClass: "fl m-l-20",
    attrs: {
      "type": "primary",
      "disabled": _vm.disable
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("提交")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ae43ed0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/changePwd.vue
// module id = 1803
// module chunks = 2